export default __webpack_public_path__ + "static/media/explore3.36101a61.png";